<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Relatórios</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHide()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table">
                <div class="box-typical-body">
                  <div class="container-fluid">
                    <div class="row loadingDataPosition">
                      <div class="loadingData" v-if="loading">
                        <div class="loadingDataSpinner">
                          <spinner
                            v-if="loading"
                            text-fg-color="#ffffff"
                            message="Carregando..."
                          ></spinner>
                        </div>
                      </div>
                      <div class="container-fluid">
                        <h5>Relatório Pré Fatura Receita</h5>
                        <b-row no-gutters>
                          <b-col sm="6" md="2" class="p-0">
                            <b-form-datepicker
                              locale="pt-br"
                              reset-button
                              placeholder="Data Inicio"
                              v-model="form.dt_ini"
                              class="form-control"
                              :date-format-options="{
                                day: 'numeric',
                                month: 'numeric',
                                year: 'numeric',
                              }"
                              @keyup.enter="doFilter"
                            >
                            </b-form-datepicker>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <b-form-datepicker
                              locale="pt-br"
                              reset-button
                              placeholder="Data Fim"
                              v-model="form.dt_fim"
                              class="form-control"
                              :date-format-options="{
                                day: 'numeric',
                                month: 'numeric',
                                year: 'numeric',
                              }"
                              @keyup.enter="doFilter"
                            >
                            </b-form-datepicker>
                          </b-col>
                          <b-col sm="6" md="4" class="p-0">
                            <!-- <label>Tabela de frete</label> -->
                            <multiselect
                              v-model="unidades"
                              :options="this.unidades2"
                              track-by="value"
                              label="label"
                              :multiple="true"
                              group-values="unidade"
                              group-label="descr"
                              :group-select="true"
                              :clear-on-select="false"
                              :hide-selected="true"
                              placeholder="Unidade"
                              tag-placeholder=""
                              select-label=""
                              selected-label="Selecionado"
                              deselect-label="Remover"
                              selectGroupLabel="Adicionar todas Unidades"
                              deselectGroupLabel="Remover todas Unidades"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <!-- <label>Tabela de frete</label> -->
                            <multiselect
                              v-model="statusSelected"
                              :options="optionsStatus"
                              track-by="value"
                              label="label"
                              :clear-on-select="false"
                              :hide-selected="true"
                              placeholder="Situação"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="4" class="p-0">
                            <multiselect
                              v-model="clienteSelected"
                              :options-limit="300"
                              :limit="2"
                              :limit-text="limitText"
                              :options="optionsCliente"
                              track-by="value"
                              label="label"
                              id="cliente"
                              :hide-selected="true"
                              placeholder="Cliente ( Digite 3 caracteres para pesquisar )"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                              :searchable="true"
                              :loading="isLoadingCliente"
                              @search-change="listaClientes"
                            ></multiselect>
                          </b-col>
                          <b-btn
                            @click="doGerar(1)"
                            variant="secondary"
                            :disabled="isDisabled"
                          >
                            Extrair
                          </b-btn>
                          <b-btn @click="doLimpar(1)" variant="secondary">
                            Limpar
                          </b-btn>
                          <b-col
                            class="p-0"
                            style="
                              display: flex;
                              align-items: center;
                              margin-left: 5px;
                            "
                          >
                            <AvisoErros
                              v-bind:errors_array="errors_array"
                            ></AvisoErros>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import AvisoErros from "../../components/AvisoErros";

export default {
  components: {
    AvisoErros,
  },
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      loading: false,
      isDisabled: false,
      loadingData: false,
      isFullscreen: false,
      showModal: false,
      unidades: [],
      statusSelected: [],
      clienteSelected: [],
      optionsCliente: [],
      optionsStatus: [],
      errors_array: [],
      unidades2: [
        {
          descr: "Unidades",
          unidade: [],
        },
      ],
      optionsUnidade: [],
      helpForm: new Form({ statusRecord: [], params: [], search: "" }),
      isLoadingCliente: false,
      form: new Form({
        cliente_id: "",
        status: "",
        dt_ini: "",
        dt_fim: "",
        unidades: [],
        pessoa_id: "",
      }),
    };
  },
  watch: {
    statusSelected(obj) {
      this.form.status = obj.value;
    },
    clienteSelected(obj) {
      this.form.cliente_id = obj.value;
    },
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  methods: {
    doGerar() {
      this.loading = true;
      this.isDisabled = true;
      this.unidades.forEach((obj) => {
        this.form.unidades.push(obj.value);
      });
      this.form
        .post("/api/relatorio/prefaturareceita")
        .then((response) => {
          new ReturnApi(response, this);
          this.errors_array = "";
          this.errors_array = [];
          this.form.unidades = [];
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          this.form.unidades = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    doLimpar() {
      this.form.dt_ini = "";
      this.form.fim = "";
      this.unidades = [];
      this.form.unidades = [];
      this.unidades2[0].unidades = [];
      this.statusSelected = [];
      this.errors_array = [];
      this.clienteSelected = [];
    },
    listaClientes(search) {
      if (search.length >= 3) {
        this.isLoadingCliente = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/cliente")
          .then((response) => {
            this.optionsCliente = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsCliente.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ).replace(
                      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                      "$1.$2.$3/$4-$5"
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsCliente.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsCliente.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingCliente = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    getLivGeral() {
      this.helpForm
        .get("/api/relatorio/prefaturareceita/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.status.forEach((obj) => {
            this.optionsStatus.push({ label: obj.descr, value: obj.valor });
          });
          response.unidade.forEach((obj) => {
            this.unidades2[0].unidade.push({
              label: obj.descr,
              value: obj.unidade_id,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;
      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
